module.exports = __webpack_public_path__ + "img/des-3.3aaa6546.jpg";